import { createSlice } from "@reduxjs/toolkit";
import { API_STATUSES } from "redux/_helpers/statuses";

const fleetReducers = createSlice({
  name: "fleetReducers",
  initialState: {
    getSsidDataStatus: API_STATUSES.REQUEST,
    getSsidData: [],
    setSsidDataStatus: API_STATUSES.REQUEST,
    setSsidData: [],
    engineSerialStatus: API_STATUSES.REQUEST,
    engineSerialData: []
  },

  reducers: {
    getSsidDataStatus: (state, action) => {
      state.getSsidDataStatus = action.payload;
    },
    getSsidData: (state, action) => {
      state.getSsidData = action.payload;
    },
    setSsidDataStatus: (state, action) => {
      state.setSsidDataStatus = action.payload;
    },
    setSsidData: (state, action) => {
      state.setSsidData = action.payload;
    },
    engineSerialStatus: (state, action) => {
      state.engineSerialStatus = action.payload;
    },
    engineSerialData: (state, action) => {
      state.engineSerialData = action.payload;
    }
  },
});

export const {
  getSsidDataStatus,
  getSsidData,
  setSsidDataStatus,
  setSsidData,
  engineSerialStatus,
  engineSerialData
} = fleetReducers.actions;

export default fleetReducers.reducer;
